export { default as ProfileDetailsPage } from "./ProfileDetailsPage";
